import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PaperClipOutlinedSvg from "@ant-design/icons-svg/es/asn/PaperClipOutlined";
import AntdIcon from '../components/AntdIcon';
var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PaperClipOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PaperClipOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PaperClipOutlined';
}
export default RefIcon;